import { useEffect, useRef, useState } from "react";
import { Button, Input, Space, Grid } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";

export default function PatientKvkk({ patientId, onApproved, onCancel }) {
    const [password, setPassword] = useState("");
    const [time, setTime] = useState(0);
    const [error, setError] = useState(false);
    const timer = useRef(null)
    const [patient, setPatient] = useState({});
    const screens = Grid.useBreakpoint();

    const sendKvkkMessage = async (type) => {
        setError(false)
        const res = await ApiService.Patient.SendKvkkCode(patientId, type);
        if (res.success) {
            setTime(30)
            timer.current = setInterval(() => {
                setTime((prevState) => {
                    if (prevState <= 1) {
                        clearInterval(timer.current);
                        return 0;
                    }
                    return prevState - 1;
                })
            }, 1000)
        }
    };

    const skipKvkk = async () => {
        const res = await ApiService.Patient.SkipKvkk(patientId);
        if (res.success) {
            onApproved();
        }
    }

    const handleInputChange = (e) => {
        setPassword(e.target.value);
    };

    const approveKvkk = async () => {
        const res = await ApiService.Patient.ApproveKvkk(patientId, {
            code: password
        });

        if (res.success && res.data) {
            onApproved();
        }
        else {
            setError(true);
        }
    };

    const getPatient = async () => {
        const res = await ApiService.Patient.GetPatient(patientId);
        if (res.success) {
            setPatient(res.data);
        }
    }

    useEffect(() => {
        getPatient()
    }, [patientId]);

    return (
        <div>
            {
                time === 0 && (
                    <div style={{ display: 'flex', flexDirection: !screens.md ? 'column' : 'row', justifyContent: 'start', gap: 8 }}>
                        {
                            patient?.phone1 && (
                                <Button type="primary" onClick={() => { sendKvkkMessage('phone') }} style={!screens.md ? { width: '100%' } : {}}>
                                    {t('Send KVKK Approval Code (SMS)')}
                                </Button>
                            )
                        }
                        {
                            patient?.email && (
                                <Button type="primary" onClick={() => { sendKvkkMessage('email') }} style={!screens.md ? { width: '100%' } : {}}>
                                    {t('Send KVKK Approval Code (Email)')}
                                </Button>
                            )
                        }
                        <Button type="danger" onClick={skipKvkk} style={!screens.md ? { width: '100%' } : {}}>
                            {t('Skip KVKK Approval')}
                        </Button>
                    </div>
                )
            }
            {
                time > 0 && (
                    <Space direction="vertical" style={{ marginTop: 16 }}>
                        <Input
                            placeholder={t('Enter Code')}
                            value={password}
                            onChange={handleInputChange}
                        />
                        <Button type="primary" onClick={approveKvkk}>
                            {t('Submit')} ({time} s)
                        </Button>
                    </Space>
                )
            }
            {error && <div style={{ color: 'red' }}>{t('Invalid code, please try again.')}</div>}
        </div>
    );
}